import {
    IDevConfigInterface,
    IProdConfigInterface,
    IStageConfigInterface,
  } from "@/configs/interface";
  import envConfig from "envConfig";
  
  export const useQuickCommerce = () => {
    const quickCommerce = envConfig as
      | IProdConfigInterface
      | IDevConfigInterface
      | IStageConfigInterface;
    return quickCommerce;
  };
  